import { ChangeEvent, FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Input } from 'src/components/common/Input';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useResetSignUpError } from 'src/hooks/useResetSignupErrors';
import { setError } from 'src/store/user/actions';
import { RootState } from 'src/types/store-types';
import * as Yup from 'yup';

type IProps = {
  name: string;
  value: string;
  regexp: string;
  onChange: (e: any) => void;
  placeholder?: string;
  required?: boolean;
};
const ZipCode_Input: FC<IProps> = (props) => {
  // Hooks
  const { t }: Translation = useTranslation();

  // Redux
  const _setErrorReq = useConnectedAction(setError);
  const resetSignUpError = useResetSignUpError();

  // Selectors
  const { errors: signUpErrors, dniResult } = useSelector((state: RootState) => state.user);
  const { zipCode } = dniResult || {};
  // YUP Validation
  const validationSchema = Yup.object().shape({
    zipCode: Yup.string().required(t('requiredField')).matches(new RegExp(props.regexp), t('zipfieldLength')),
  });

  const handleValidate = async (value: string): Promise<void> => {
    try {
      await validationSchema.validate({ zipCode: value }, { abortEarly: false });
      resetSignUpError('zipCode');
    } catch (error: any) {
      if (error.name === 'ValidationError') {
        _setErrorReq({ ...signUpErrors, zipCode: error.errors[0] });
      }
    }
  };

  // Actions
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>): void => {
    if (signUpErrors.zipCode) {
      resetSignUpError('zipCode');
    }
    props.onChange(e);
  };

  const handleBlur = (): void => {
    handleValidate(props.value?.trim());
  };

  useEffect(() => {
    if (Object.keys(dniResult).length) {
      props.onChange({
        target: {
          name: props.name,
          value: Number(zipCode),
        },
      });
      handleValidate(zipCode);
    }
  }, [dniResult]);

  return (
    <Input
      error={signUpErrors.zipCode}
      {...props}
      onChange={handleOnChange}
      onBlur={handleBlur}
      type="number"
      disableNumberSymbols
    />
  );
};
export default ZipCode_Input;
